import { QUICK_GOOGLE_REVIEW_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';
import { paramsToQueryString } from '../../../utility/helpers/commonFunction';

// ── Dashboard card counts ──────────────────────────────────────────────────
export const getReviewRequestCards = async () => {
    const response = await instance.get(QUICK_GOOGLE_REVIEW_ROUTES.GET_CARDS_COUNT);
    return response?.data?.data;
};

// ── Review request listing ─────────────────────────────────────────────────
export const getReviewRequestListing = async (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((v) => {
                searchParams.append(key, v);
            });
        } else {
            searchParams.append(key, value);
        }
    });

    const queryString = searchParams.toString().replace(/\+/g, '%20');
    const response = await instance.get(QUICK_GOOGLE_REVIEW_ROUTES.GET_REQUESTS + '?' + queryString);
    return response.data?.data;
};

// ── Quick review users ───────────────────────────────────────────────────
export const getQuickReviewUsersApi = async (params) => {
    const queryParams = paramsToQueryString(params);
    const response = await instance.get(QUICK_GOOGLE_REVIEW_ROUTES.GET_QUICK_REVIEW_USERS + queryParams);

    return response?.data?.data;
};

// Create new google reviews
export const createReviewRequestApi = async (payload) => {
    const response = await instance.post(QUICK_GOOGLE_REVIEW_ROUTES.CREATE_REQUEST, payload);

    return response?.data;
};
